import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { DiskBadgeContainer, FlagIconContainer, FlagIconWrap, ImgWrap, SecondFlagIconWrap } from './styles';
import { FlagIcon } from '../FlagIcon/FlagIcon';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';

const getIconColor = (variant, isDisabled, isInactive) => {
    switch (variant) {
        case 'primary':
            return 'white';
        case 'secondary':
            return isDisabled ? 'purpleRgba24' : isInactive ? 'purpleRgba40' : 'purple';
        case 'tertiary':
            return isDisabled ? 'lightGray' : isInactive ? 'mediumGray' : 'darkGray';
        case 'selectedPassive':
            return 'purple';
        case 'transparent':
            return 'purple';
        default:
            return 'darkGray';
    }
};

export const DiskBadge = ({ isDisabled, isInactive, variant = 'tertiary', diskSize = 'small', logoSymbol, ...props }) => {
    const [errorImageLoading, setErrorImageLoading] = useState(false);

    useEffect(() => {
        setErrorImageLoading(false);
    }, [props.src]);

    return (
        <DiskBadgeContainer
            variant={errorImageLoading ? 'tertiary' : variant}
            diskSize={diskSize}
            isDisabled={isDisabled}
            isInactive={isInactive}
            noBorder={!!props.src}
        >
            {props.iconName && !errorImageLoading && (
                <Icon name={props.iconName} color={getIconColor(variant, isDisabled, isInactive)} size={diskSize === 'large' ? '48px' : '24px'} />
            )}
            {/*Загрузка аватарки*/}
            {props.src && !errorImageLoading && (
                <ImgWrap isDisabled={isDisabled} isInactive={isInactive} withoutRadius={props.withoutRadius} diskSize={diskSize} variant={variant}>
                    <img src={props.src} alt={props.alt} onError={(e) => (props.onError ? props.onError(e) : setErrorImageLoading(true))} />
                </ImgWrap>
            )}
            {/*Текст вместо иконки или аватарки*/}
            {props.diskText && (
                <Text size={diskSize === 'large' ? 'header' : 'main'} color={getIconColor(variant, isDisabled, isInactive)}>
                    {props.diskText}
                </Text>
            )}
            {/*обработка ошибок загрузки изображения*/}
            {errorImageLoading && (
                <Text size={diskSize === 'large' ? 'header' : 'main'} color={getIconColor(variant, isDisabled, isInactive)}>
                    {logoSymbol}
                </Text>
            )}
            {props.flagName && (
                <FlagIconWrap>
                    <FlagIconContainer isDisabled={isDisabled} isInactive={isInactive}>
                        <FlagIcon name={props.flagName} size={diskSize === 'large' ? 'x-small' : '16px'} />
                    </FlagIconContainer>
                </FlagIconWrap>
            )}
            {props.secondFlagName && (
                <SecondFlagIconWrap>
                    <FlagIconContainer isDisabled={isDisabled} isInactive={isInactive}>
                        <FlagIcon name={props.secondFlagName} size={diskSize === 'large' ? 'x-small' : '16px'} />
                    </FlagIconContainer>
                </SecondFlagIconWrap>
            )}
        </DiskBadgeContainer>
    );
};

DiskBadge.propTypes = {
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'letterIndex', 'selectedPassive', 'transparent', 'hasBorderedImg']),
    diskSize: PropTypes.oneOf(['x-small', 'small', 'fixed-small', 'large']),
    isDisabled: PropTypes.bool,
    isInactive: PropTypes.bool,
    iconName: PropTypes.string,
    flagName: PropTypes.string,
    secondFlagName: PropTypes.string,
    diskText: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string,
    logoSymbol: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    withoutRadius: PropTypes.bool,
    onError: PropTypes.func,
};
